export default __webpack_public_path__ + "static/media/Beard_3_C4.df9be339.svg";